// extracted by mini-css-extract-plugin
export default {"header":"styles_header__LVr7a","titleWrapper":"styles_titleWrapper__WKRsv","drawerHeaderIcon":"styles_drawerHeaderIcon__-jeow"};